<template>
  <div class="wrap myoreders-wrap personal-wrap flex-column">
    <!-- 搜索框 -->
    <div class="input-box flex-row">
      <input
        class="serarch-input flex-item"
        type="text"
        name=""
        placeholder="搜索线上订单"
        v-model="queryText"
        :autofocus="true"
        @change="searchOrder()"
      />
      <span class="search-btn blue" @click="jumpSearchBelowOrders()"
        >线下订单</span
      >
      <!-- <span class="search-btn" @click="searchOrder()">搜索</span> -->
    </div>
    <div class="mytabs">
      <div
        class="tab"
        @click="stateClick(1)"
        :class="{ active: activeTab == 'tab' + 1 }"
      >
        <mu-badge
          :content="String(allMemOrderCount)"
          circle
          secondary
          v-bind:badgeClass="[
            allMemOrderCount == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>全部</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(2)"
        :class="{ active: activeTab == 'tab' + 2 }"
      >
        <mu-badge
          :content="String(countNumber.waitPayNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.waitPayNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>待支付</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(3)"
        :class="{ active: activeTab == 'tab' + 3 }"
      >
        <mu-badge
          :content="String(countNumber.payedNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.payedNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>支付完成</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(4)"
        :class="{ active: activeTab == 'tab' + 4 }"
      >
        <mu-badge
          :content="String(countNumber.productNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.productNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>生产中</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(5)"
        :class="{ active: activeTab == 'tab' + 5 }"
      >
        <mu-badge
          :content="String(countNumber.shippedNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.shippedNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>已发货</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(6)"
        :class="{ active: activeTab == 'tab' + 6 }"
      >
        <mu-badge
          :content="String(countNumber.installedNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.installedNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>安装完成</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(7)"
        :class="{ active: activeTab == 'tab' + 7 }"
      >
        <mu-badge
          :content="String(countNumber.commentedNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.commentedNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>已评价</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(8)"
        :class="{ active: activeTab == 'tab' + 8 }"
      >
        <mu-badge
          :content="String(countNumber.canceledNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.canceledNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>已取消</p>
        </mu-badge>
      </div>
      <div
        class="tab"
        @click="stateClick(9)"
        :class="{ active: activeTab == 'tab' + 9 }"
      >
        <mu-badge
          :content="String(countNumber.backedNum)"
          circle
          secondary
          v-bind:badgeClass="[
            countNumber.backedNum == 0 || loadorderCount
              ? 'none-badge'
              : 'custom-badge',
          ]"
        >
          <p>已退单</p>
        </mu-badge>
      </div>
    </div>
    <mu-infinite-scroll
      :loading="loadShow"
      loadingText="拼命加载中"
      class="load"
      v-if="loadShow"
    />
    <empty
      imgpath="/static/images/empty_orders_3x.png"
      emptytext="您还没有相关订单"
      btntext="去逛一逛"
      btnurl="/main/home"
      v-if="pageMemOrderList.length == 0 && !loadShow"
    ></empty>
    <!-- 全部 -->
    <div
      class="orders-list flex-item tab1"
      v-show="pageMemOrderList.length != 0 && !loadShow"
    >
      <!-- v-if="activeTab === 'tab1'"> -->
      <div class="orders-list-item" v-for="orderDetail in pageMemOrderList">
        <div
          class="orders-list-item-title"
          @click="
            gotoOrderDetail(
              orderDetail.stOrderId,
              orderDetail.orderState,
              orderDetail.commonFinished
            )
          "
        >
          订单号：{{ orderDetail.stOrderId }}
          <p class="fr">{{ orderDetail.storeName }}</p>
          <img class="fr" src="/static/images/mexin_logo_3x.png" />
        </div>
        <div class="orders-list-item-state">
          <div
            class="state"
            @click="
              gotoOrderDetail(
                orderDetail.stOrderId,
                orderDetail.orderState,
                orderDetail.commonFinished
              )
            "
          >
            状态：<span class="blue">{{ orderDetail.orderStateName }}</span>
            <br />
            总价：
            <span class="primary">￥{{ orderDetail.finalPrice }}</span>
          </div>
          <div class="operate">
            <!-- <mu-raised-button label="立即支付" class="orders-button" v-if="orderDetail.orderState==0" primary @click="orderSubmit(0,orderDetail.stOrderId,orderDetail.orderId)" /> -->
            <mu-raised-button
              label="立即支付"
              class="orders-button"
              v-if="orderDetail.orderState == 0"
              primary
              @click="
                gotoOrderDetail(
                  orderDetail.stOrderId,
                  orderDetail.orderState,
                  orderDetail.commonFinished
                )
              "
            />
            <mu-raised-button
              label="取消订单"
              v-if="orderDetail.orderState == 0"
              class="orders-button mu-raised-button-grad"
              @click="
                cancelOrder(orderDetail.orderState, orderDetail.stOrderId)
              "
            />
            <mu-raised-button
              label="申请退单"
              v-if="
                orderDetail.orderState == 1 ||
                orderDetail.orderState == 3 ||
                orderDetail.orderState == 4 ||
                orderDetail.orderState == 12 ||
                orderDetail.orderState == 13
              "
              class="orders-button mu-raised-button-grad"
              @click="
                cancelOrder(orderDetail.orderState, orderDetail.stOrderId)
              "
            />
            <mu-raised-button
              label="晒家分享"
              v-if="orderDetail.orderState == 9"
              class="orders-button"
              @click="shareJump(orderDetail.stOrderId, orderDetail.orderId)"
            />
            <!-- -->
            <mu-raised-button
              label="去评价"
              v-if="
                orderDetail.orderState == 9 &&
                orderDetail.commonFinished == false
              "
              class="orders-button"
              @click="evaluateJump(orderDetail.stOrderId, orderDetail.orderId)"
              primary
            />
            <mu-raised-button
              label="立即购买"
              v-if="orderDetail.orderState == 2 || orderDetail.orderState == 10"
              class="orders-button mu-raised-button-grad"
              @click="buyNow(orderDetail.stOrderId, orderDetail.orderId)"
            />
          </div>
        </div>
        <mu-list
          @click="
            gotoOrderDetail(
              orderDetail.stOrderId,
              orderDetail.orderState,
              orderDetail.commonFinished
            )
          "
        >
          <div
            v-if="
              orderDetail &&
              orderDetail.goodsOrderMsgs &&
              orderDetail.goodsOrderMsgs.length > 0
            "
          >
            <myOrdersItem
              :width="150"
              :height="150"
              v-for="(listShop, shopIndex) in orderDetail.goodsOrderMsgs"
              :cartitem="listShop"
              :key="shopIndex"
            >
            </myOrdersItem>
          </div>
        </mu-list>
      </div>
      <mu-infinite-scroll
        :scroller="scroller"
        :loading="loading"
        loadingText=""
        @load="loadMore"
      />
      <p
        class="none-goods"
        v-if="
          (lastPageNo == currentPage && !loadShow) || (total == 0 && !loadShow)
        "
      >
        没有更多订单啦~
      </p>
    </div>
    <mu-dialog
      :open="quitOrder"
      title="取消订单"
      titleClass="dialogTitle"
      bodyClass="dialogBody"
      actionsContainerClass="dialogActionsContainer"
      @close="closeQuitOrder"
    >
      您确定要取消这个订单么?
      <mu-flat-button
        slot="actions"
        @click="closeQuitOrder"
        primary
        label="否"
      />
      <mu-flat-button
        slot="actions"
        primary
        @click="doQuitOrder(1)"
        label="是"
      />
    </mu-dialog>
    <mu-dialog
      :open="chargeBack"
      title="申请退单"
      titleClass="dialogTitle"
      bodyClass="dialogBody"
      actionsContainerClass="dialogActionsContainer"
      @close="closeChargeBack"
    >
      您确定要申请退单么?
      <mu-flat-button
        slot="actions"
        @click="closeChargeBack"
        primary
        label="否"
      />
      <mu-flat-button
        slot="actions"
        primary
        @click="doChargeBack()"
        label="是"
      />
    </mu-dialog>
    <mu-dialog
      :open="contactService"
      title="申请退单请联系客服"
      titleClass="dialogTitle"
      bodyClass="dialogBody"
      actionsContainerClass="dialogActionsContainer fullContainer"
      @close="contactService = false"
    >
      400-832-2777
      <!-- <mu-flat-button slot="actions" @click="closeContactService" primary label="否"/> -->
      <mu-flat-button
        slot="actions"
        primary
        label="确定"
        @click="phoneCall('400-832-2777')"
      />
    </mu-dialog>
    <mu-toast
      v-if="toast.isShow"
      :message="toast.messageTip"
      class="custom-toast"
    />
  </div>
</template>
<script type="text/javascript">
import imgs from "@components/image/image";
import menus from "@components/menus/menus";
import myOrdersItem from "@components/myOrdersItem/myOrdersItem";
import empty from "@components/empty/empty";
import { mapActions, mapGetters } from "vuex";
import { storage } from "@common/utils/util.js";
export default {
  data() {
    return {
      type: this.$route.query.type || 1, //订单类别
      loadShow: true, //加载
      loadorderCount: true, //加载订单数量
      quitOrder: false, //取消订单
      chargeBack: false, //申请退单
      contactService: false, //生产中、已发货  联系客服
      activeTab: "tab1",
      value: [], //选中的id
      scrolled: 0, //监听滚动事件
      num: 3,
      loading: false,
      scroller: null,
      pageMemOrderList: [], //获取列表
      pageNo: 1, //页码
      pageSize: 10, //页量
      total: 0, //z总数量
      lastPageNo: 1, //总共页面数量
      currentPage: 0,
      orderTab: this.$route.query.type ? this.$route.query.type : 1, //查询条件
      queryText: "",
      countNumber: {},
      allMemOrderCount: null,
      memOrderDetailMsg: [],
      settleDatas: [],
      settleDatas: [],
      OrderSettleMsg: "",
      toast: {
        isShow: false,
        messageTip: "",
      },
    };
  },
  mounted() {
    this.scroller = document.querySelectorAll(".orders-list")[0];
  },
  methods: {
    ...mapActions({
      getMemOrderCount: "getMemOrderCount", //查询各个订单数
      pageMemOrder: "pageMemOrder", //分页查询订单
      cancelMemOrder: "cancelMemOrder", //取消订单
      applyBackOrder: "applyBackOrder", //申请退单
      getOrderSettleMsgForOrder: "getOrderSettleMsgForOrder", //重新购买
    }),
    showTipMessage(isShow, msg) {
      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(() => {
        this.toast.isShow = false;
      }, 500);
    },
    //搜索订单
    searchOrder() {
      if (this.queryText == "") {
        return;
      }
      this.orderTab = 1;
      this.getPageMemOrder(
        this.queryText,
        this.orderTab,
        this.pageNo,
        this.pageSize
      );
    },
    //判断是取消订单还是申请退单还是线下操作
    cancelOrder(stated, stOrderId) {
      this.stOrderId = stOrderId;
      if (stated == 0) {
        this.quitOrder = true;
      } else if (stated == 4 || stated == 1 || stated == 3) {
        this.chargeBack = true;
      } else {
        this.contactService = true;
      }
    },
    jumpSearchBelowOrders() {
      this.$router.push({ path: "/main/searchbeloworders" });
    },
    shareJump(stOrderId, orderId) {
      this.$router.push({
        path:
          "/main/publishsunhome?stOrderId=" + stOrderId + "&orderId=" + orderId,
      });
    },
    //跳转去评价
    evaluateJump(stOrderId, orderId) {
      this.$router.push({
        path: "/main/evaluation?stOrderId=" + stOrderId + "&orderId=" + orderId,
      });
      //this.$router.push({ path: '/main/quitsuccess' });
    },
    // 初始化店铺结算信息
    initSettleDatas(stOrderId, OrderSettleMsg) {
      let _this = this;
      let settleDatas = [];
      let couponAmounts = [];
      let redpacketAmounts = [];
      console.log(OrderSettleMsg);
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用优惠券",
            couponAmount: 0,
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用红包",
            couponAmount: 0,
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        let instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function (sub) {
          //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });
        settleDatas.push({
          stOrderId: stOrderId,
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId: "0",
          remark: "",
          dealerCode: "",
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0);
        redpacketAmounts.push(0);
      });
      let orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      storage.local.set("orderData", orderData);
    },
    //立即支付
    orderSubmit(id, stOrderId, orderId) {
      let _this = this;
      this.getOrderSettleMsgForOrder(stOrderId).then((res) => {
        this.OrderSettleMsg = res.target.target;
        this.initSettleDatas(stOrderId, res.target.target); // 初始化店铺结算信息
        this.$router.push({
          path: "/main/firmorder?orderId=" + orderId,
        });
      });
    },
    //立即购买
    buyNow(stOrderId, orderId) {
      let _this = this;
      this.getOrderSettleMsgForOrder(stOrderId).then((res) => {
        this.initSettleDatas(stOrderId, res.target.target); // 初始化店铺结算信息
        this.$router.push({
          path: "/main/firmorder",
        });
      });
    },
    //不同状态的订单;
    stateClick(upNo) {
      if (this.activeTab == "tab" + upNo) {
        return false;
      }
      this.loadShow = true; //加载
      this.orderTab = upNo;
      this.activeTab = "tab" + upNo;
      // 数据列表清空
      this.pageNo = 1;
      this.pageMemOrderList = [];
      this.getPageMemOrder(
        this.queryText,
        this.orderTab,
        this.pageNo,
        this.pageSize
      );
      this.getMemOrderCountWay();
    },
    //跳转订单详情
    gotoOrderDetail(stOrderId, orderState, commonFinished) {
      // console.log('去评价', commonFinished);
      this.$router.push({
        path:
          "/main/orderdetail?stOrderId=" +
          stOrderId +
          "&orderState=" +
          orderState +
          "&commonFinished= " +
          commonFinished,
      });
      return;
    },
    // 加载更多
    loadMore() {
      if (this.lastPageNo == this.pageNo) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.getPageMemOrder(
          this.queryText,
          this.orderTab,
          this.pageNo,
          this.pageSize
        );
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
    },
    //状态栏切换
    handleTabChange(val) {
      this.activeTab = val;
    },
    //取消订单
    doQuitOrder(id) {
      this.getCancelMemOrder(this.stOrderId);
    },
    //关闭取消订单弹框
    closeQuitOrder() {
      this.quitOrder = false;
    },
    //关闭联系客服
    closeContactService() {
      this.contactService = false;
    },
    //拨打电话
    phoneCall(tel) {
      this.contactService = false;
      window.location.href = "tel://" + tel;
    },
    //申请退单
    doChargeBack() {
      this.getApplyBackOrder(this.stOrderId);
      this.chargeBack = false;
    },
    //关闭申请退单弹框
    closeChargeBack() {
      this.chargeBack = false;
    },
    //立即支付
    goPay(id) {
      console.log("支付" + id);
    },
    //进入订单详情
    orderdetail() {
      this.$router.push({
        path: "/main/orderdetail",
      });
    },
    //获取订单列表详情api
    getPageMemOrder(queryText, orderTab, pageNo, pageSize) {
      this.pageMemOrder([queryText, orderTab, pageNo, pageSize])
        .then((res) => {
          this.loadShow = false; //加载关闭
          // this.pageMemOrderList = res.result;
          res.result.forEach((item) => {
            this.pageMemOrderList.push(item);
          });
          this.lastPageNo = Number(res.lastPageNo);
          this.currentPage = Number(res.currentPageNo);
          this.total = Number(res.totalCount);
        })
        .catch((error) => {
          this.showTipMessage(true, error || "获取数据失败,请稍后重试");
        });
    },
    //取消订单api
    getCancelMemOrder(stOrderId) {
      this.cancelMemOrder(stOrderId)
        .then((res) => {
          this.showTipMessage(true, "已成功取消订单");
          this.quitOrder = false;
          // 数据列表清空
          this.pageNo = 1;
          this.pageMemOrderList = [];
          this.getPageMemOrder(
            this.queryText,
            this.orderTab,
            this.pageNo,
            this.pageSize
          );
          this.getMemOrderCountWay();
        })
        .catch((error) => {
          this.showTipMessage(true, error || "取消失败,请稍后重试");
        });
    }, //申请退单api
    getApplyBackOrder(stOrderId) {
      this.applyBackOrder([stOrderId, "mobile"])
        .then((res) => {
          this.showTipMessage(true, "退单申请已提交");
          this.getMemOrderCountWay();
          // 数据列表清空
          this.pageNo = 1;
          this.pageMemOrderList = [];
          this.getPageMemOrder(
            this.queryText,
            this.orderTab,
            this.pageNo,
            this.pageSize
          );
        })
        .catch((error) => {
          this.showTipMessage(true, error || "退单失败,请稍后重试");
        });
    },
    //查询各自订单数
    getMemOrderCountWay() {
      this.getMemOrderCount().then((res) => {
        this.countNumber = res;
        this.allMemOrderCount =
          parseInt(this.countNumber.waitPayNum) +
          parseInt(this.countNumber.payedNum) +
          parseInt(this.countNumber.productNum) +
          parseInt(this.countNumber.shippedNum) +
          parseInt(this.countNumber.installedNum) +
          parseInt(this.countNumber.canceledNum) +
          parseInt(this.countNumber.backedNum) +
          parseInt(this.countNumber.commentedNum);
        this.loadorderCount = false;
      });
    },
  },
  watch: {},
  created() {
    this.getMemOrderCountWay(); //订单数量
    this.getPageMemOrder(
      this.queryText,
      this.orderTab,
      this.pageNo,
      this.pageSize
    ); //分页查询我的订单
    this.activeTab = "tab" + this.$route.query.type || "1";
  },
  components: {
    imgs,
    menus,
    myOrdersItem,
    empty,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "personal.scss";
.myoreders-wrap {
  .input-box {
    width: 100%;
    padding: 0.2rem 0;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);
    z-index: 2;
    text-align: center;
    .serarch-input {
      /*display: inline-block;*/
      /*width: 75%;*/
      margin: 0 0.266667rem;
      height: 0.7rem;
      /*margin: 0 auto;*/
      border-radius: 0.675rem;
      @include sInput(#efefef, center, #999999);
      background: url(/static/images/productList_search@3x.png) no-repeat
        0.25rem center;
      background-size: 0.45rem;
      background-color: #efefef;
    }
    .search-btn {
      display: inline-block;
      margin: 0 0.25rem;
      @include font-dpr(14px);
      color: #666666;
    }
    .search-btn.blue {
      color: #4a90e2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// myorders.vue?2534ecec